import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import AgentModel from '../models/AgentModel';
import CargoTypeModel from '../../CargoTypeSelector/models/CargoTypeModel';

interface AgentInputState {
    agentInput: AgentModel,
    selectedAgentId: string,
    agentInputExpand: boolean,
    triggerFocusCompanyNameInput: number,
    triggerSave: number,
    triggerRefreshInput: number,
}

const initialState: AgentInputState = {
    agentInput: {
        id: "",
        name: "",
        country: "",
        contactDetails: "",
        ports: [],
        cargoesHandling: [],
        remark: ""
    } as unknown as AgentModel,
    selectedAgentId: "",
    agentInputExpand: true,
    triggerFocusCompanyNameInput: 0,
    triggerSave: 0,
    triggerRefreshInput: 0,
}

export const AgentInputSlice = createSlice({
    name: "AgentInput",
    initialState,
    reducers: {
        setAgentInputId: (state, action: PayloadAction<string>) => {
            state.agentInput.id = action.payload;
        },
        setAgentInput: (state, action: PayloadAction<AgentModel>) => {
            state.agentInput = action.payload;
        },
        setAgentName: (state, action: PayloadAction<string>) => {
            state.agentInput.name = action.payload;
        },
        setCountry: (state, action: PayloadAction<string>) => {
            state.agentInput.country = action.payload;
        },
        setContactDetails: (state, action: PayloadAction<string>) => {
            state.agentInput.contactDetails = action.payload;
        },
        setPorts: (state, action: PayloadAction<number[]>) => {
            state.agentInput.ports = action.payload;
        },
        setCargoesHandling: (state, action: PayloadAction<CargoTypeModel[]>) => {
            state.agentInput.cargoesHandling = action.payload;
        },
        setRemark: (state, action: PayloadAction<string>) => {
            state.agentInput.remark = action.payload;
        },
        setSelectedAgentId: (state, action: PayloadAction<string>) => {
            state.selectedAgentId = action.payload;
        },
        setAgentInputExpand: (state, action: PayloadAction<boolean>) => {
            state.agentInputExpand = action.payload;
        },
        setTriggerFocusCompanyNameInput: (state, action: PayloadAction<number>) => {
            state.triggerFocusCompanyNameInput = action.payload;
        },
        resetAgentInput: (state) => {
            state.agentInput = initialState.agentInput;
        },
        setTriggerSave: (state, action: PayloadAction<number>) => {
            state.triggerSave = action.payload;
        },
        setTriggerRefreshInput: (state, action: PayloadAction<number>) => {
            state.triggerRefreshInput = action.payload;
        },
    }
});

export const agentInputSelector = createSelector(
    (state: RootState) => state.agentInput,
    (data) => data
);

export const {
    setAgentInputId,
    setAgentInput,
    setAgentName,
    setCountry,
    setContactDetails,
    setPorts,
    setCargoesHandling,
    setRemark,
    setSelectedAgentId,
    setAgentInputExpand,
    setTriggerFocusCompanyNameInput,
    resetAgentInput,
    setTriggerSave,
    setTriggerRefreshInput,
} = AgentInputSlice.actions;

export default AgentInputSlice.reducer;